import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { MemberOverview } from './pages/member/Overview';
import { MyContributions } from './pages/member/Contributions';
import { MyBenefits } from './pages/member/Benefits';
import { MyVoluntarySavings } from './pages/member/Voluntary';
import { StaffDashboard } from './pages/spf-staff/Dashboard';
import { StaffMembers } from './pages/spf-staff/Members';
import { StaffContributions } from './pages/spf-staff/Contributions';
import { StaffBenefitClaims } from './pages/spf-staff/BenefitClaims';
import { StaffVoluntarySavings } from './pages/spf-staff/VoluntarySavings';
import { StaffInvestments } from './pages/spf-staff/Investments';
import { StaffActuarial } from './pages/spf-staff/Actuarial';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${persona.workspace}`} replace />} />

      <Route
        path="/member"
        element={
          <Shell
            title="Member self-service"
            items={[
              { to: '/member', label: 'Overview', icon: '◫' },
              { to: '/member/contributions', label: 'My Contributions', icon: '≣' },
              { to: '/member/benefits', label: 'My Benefits', icon: '✓' },
              { to: '/member/voluntary', label: 'My Voluntary Savings', icon: '⊙' },
            ]}
          />
        }
      >
        <Route index element={<MemberOverview />} />
        <Route path="contributions" element={<MyContributions />} />
        <Route path="benefits" element={<MyBenefits />} />
        <Route path="voluntary" element={<MyVoluntarySavings />} />
      </Route>

      <Route
        path="/spf-staff"
        element={
          <Shell
            title="SPF back office"
            items={[
              { to: '/spf-staff', label: 'Dashboard', icon: '◫' },
              { to: '/spf-staff/members', label: 'Members', icon: '⌂' },
              { to: '/spf-staff/contributions', label: 'Contributions', icon: '≣' },
              { to: '/spf-staff/benefit-claims', label: 'Benefit Claims', icon: '✓' },
              { to: '/spf-staff/voluntary-savings', label: 'Voluntary Savings', icon: '⊙' },
              { to: '/spf-staff/investments', label: 'Investments', icon: '◈' },
              { to: '/spf-staff/actuarial', label: 'Actuarial', icon: '∑' },
            ]}
          />
        }
      >
        <Route index element={<StaffDashboard />} />
        <Route path="members" element={<StaffMembers />} />
        <Route path="contributions" element={<StaffContributions />} />
        <Route path="benefit-claims" element={<StaffBenefitClaims />} />
        <Route path="voluntary-savings" element={<StaffVoluntarySavings />} />
        <Route path="investments" element={<StaffInvestments />} />
        <Route path="actuarial" element={<StaffActuarial />} />
      </Route>

      <Route path="*" element={<Navigate to={`/${persona.workspace}`} replace />} />
    </Routes>
  );
}
